import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';

interface JsonExportDialogProps {
    open: boolean;
    title: string;
    value: unknown;
    onClose: () => void;
}

const JsonExportDialog: React.FC<JsonExportDialogProps> = (props) => {
    const [copied, setCopied] = useState<string>("");
    var json = JSON.stringify(props.value, null, 2);

    const onCopy = () => {
        // navigator.clipboard is missing outside secure contexts (plain http).
        if (!navigator.clipboard) {
            setCopied("Copy not available, select the text and copy it manually");
            return;
        }
        navigator.clipboard.writeText(json).then(
            () => setCopied("Copied"),
            () => setCopied("Copy failed, select the text and copy it manually"));
    };

    const onClose = () => {
        setCopied("");
        props.onClose();
    };

    return (
        <Dialog open={props.open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent dividers>
                <TextField
                    value={json}
                    multiline
                    fullWidth
                    rows={20}
                    variant="outlined"
                    InputProps={{ readOnly: true, style: { fontFamily: "monospace", fontSize: 12 } }}
                    onFocus={e => e.target.select()}
                />
            </DialogContent>
            <DialogActions>
                {copied.length > 0 ? (<span style={{ fontSize: 12 }}>{copied}</span>) : null}
                <Button onClick={() => onCopy()} color="secondary">Copy</Button>
                <Button onClick={() => onClose()} color="primary">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default JsonExportDialog;
